import { render, staticRenderFns } from "./PhotofixrOrdersDetails.vue?vue&type=template&id=21927b95&"
import script from "./PhotofixrOrdersDetails.vue?vue&type=script&lang=js&"
export * from "./PhotofixrOrdersDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports